import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2What.module.scss'
const cx = cn.bind(s)

interface IW2WhatProps {
	className?: string
	content: IW2Content['what']
}

/** W2What block component */
const W2What: FC<IW2WhatProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle title={content?.title} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						{content?.description && <PortableBlocks blockContent={content?.description} />}
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2What.displayName = 'W2What'

export default W2What
